const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/context.ts';
import { createContext, useContext } from 'react';
import { TextFieldVariants } from '@mui/material/TextField/TextField';

export interface CIS4mContextType {
    formId: string;
    style: {
        variant: TextFieldVariants;
    };
    locked: boolean;
}

export const CIS4mContext = createContext<CIS4mContextType | undefined>(undefined);

export const useCIS4mContext = () => {
    // get the context
    const context = useContext(CIS4mContext);

    // if `undefined`, throw an error
    if (context === undefined) {
        throw new Error('useCIS4mContext was used outside of its Provider');
    }

    return context;
};
